import * as React from 'react'

import TextInput, {Props as InputProps} from './TextInput'
import {RefProp} from '../types'
import Label from '../label'

export interface Props extends InputProps {
  id: string
  displayClasses?: string
  label?: string
  hideLabel?: boolean
  descriptionText?: string
}

const LabeledTextInput: React.FC<RefProp<HTMLInputElement, Props>> = ({
  id,
  elementRef,
  displayClasses,
  label,
  hideLabel = false,
  descriptionText,
  ...rest
}) => {
  return (
    <Label
      htmlFor={id}
      displayClasses={displayClasses}
      text={label}
      hideLabel={hideLabel}
    >
      {descriptionText && (
        <span className="label__description">{descriptionText}</span>
      )}
      {rest.children}
      <TextInput id={id} ref={elementRef} {...rest} />
    </Label>
  )
}

export default React.forwardRef<
  HTMLInputElement,
  React.PropsWithChildren<Props>
>((props, ref) => <LabeledTextInput elementRef={ref} {...props} />)
